import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';

import usePublicApi from 'public-api';

import FileItemUI from './FileItemUI';

interface Props {
  fileUploadId: UUIDField;
  onRemove: () => void;
}

function FileItem({ fileUploadId, onRemove }: Props) {
  const [fileUpload, setFileUpload] = useState<Backend.FileUpload>();
  const api = usePublicApi();

  useEffect(() => {
    const load = async () => {
      const response = await api.FilesFilesApi.retrieve({ id: fileUploadId });
      setFileUpload(response);
    };

    load();
  }, [fileUploadId, api.FilesFilesApi]);

  return (
    <FileItemUI
      fileName={fileUpload?.filename}
      url={fileUpload?.file}
      isLoading={fileUpload === undefined}
      onRemove={onRemove}
    />
  );
}

export default observer(FileItem);
